import { DomHandler } from '../primeng_components/dom/domhandler';
const domHandler = new DomHandler();
const htmlEle = document.querySelector('html');
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { LZString } from 'lz-string';
import { compressToBase64 } from 'lz-string';
import { Injectable } from '@angular/core';
import { DomStorageFallbackService } from '../services/DomStorageFallback.service';
import { LoggingService } from '../services/logging/logging.service';
@Injectable()
export class AppUtility {
    scrollDuration: number = 200;
    aeSwitch = 'true';
    private portletData: any;
    // Observable string sources
    private componentMethodCallSource = new Subject<any>();

    // Observable string streams
    componentMethodCalled$ = this.componentMethodCallSource.asObservable();

    // Hide header-widget, pre-auth, newtemplate
    private redesignOnLoginSubject = new Subject<any>();
    redesignOnLoginObservable$ = this.redesignOnLoginSubject.asObservable();

    swConfig = {
        'home':
        {
            endPoints: ['header', 'footer', 'tiles']
        },
        'home-hrbpo-employee': {
            endPoints: ['header', 'footer', 'tiles']
        }
    };
    /* istanbul ignore next */
    constructor(
        private domStorageFB: DomStorageFallbackService
    ) { }

    // responsive view port classes function
    /* istanbul ignore next */
    public setViewPortClass() {
        // Add/Remove Class no-touch for desktop
        if (this.getDeviceType() === 'isMobile') {
            /* istanbul ignore next */
            domHandler.removeClass(htmlEle, 'no-touch');
        } else {
            domHandler.addClass(htmlEle, 'no-touch');
        }

        let viewPortClass;
        /* istanbul ignore next */
        if (domHandler.getViewport().width > 960) {
            viewPortClass = ' al-view-gt320 al-view-gt480 al-view-gt720 al-view-gt960 al-view-960';
        } else if (domHandler.getViewport().width <= 960 && domHandler.getViewport().width > 720) {
            viewPortClass = ' al-view-gt320 al-view-gt480 al-view-gt720 al-view-lt960 al-view-720';
        } else if (domHandler.getViewport().width <= 720 && domHandler.getViewport().width > 480) {
            viewPortClass = ' al-view-gt320 al-view-gt480 al-view-lt720 al-view-lt960 al-view-480';
        } else {
            viewPortClass = ' al-view-gt320 al-view-lt480 al-view-lt720 al-view-lt960 al-view-320';
        }

        let htmlTagClass = ' ';
        for (let i = 0; i < htmlEle.classList.length; i++) {
            if (htmlEle.classList[i].indexOf('al-view-') !== 0) {
                htmlTagClass = htmlTagClass + htmlEle.classList[i] + ' ';
            }
        }
        htmlEle.className = htmlTagClass + viewPortClass;
    }

    // Set Responsive tab Menu(Dropdown) for Mobile view
    /* istanbul ignore next */
    public setResponsiveTabMenu() {
        const tabMenu = document.querySelectorAll('.ui-tabview-menu-link');
        if (tabMenu) {
            Array.from(tabMenu).forEach(link => {
                if (link.getAttribute('listener') !== 'true') {
                    link.setAttribute('listener', 'true');
                    link.addEventListener('click', function (event) {
                        const menuElement = this.offsetParent.querySelector('.ui-tabview-nav');
                        if (getComputedStyle(menuElement).display === 'none') {
                            // show dropdown on menu click
                            menuElement.style.display = 'block';

                            // hide dropdown on outside/document click
                            document.addEventListener('click', (e) => {
                                if (!this.contains(e.target)) {
                                    menuElement.style.display = '';
                                }
                            }, false);

                        } else {
                            menuElement.style.display = '';
                        }
                    }, false);
                }
            });

            // set text on menu
            const menuItem = document.querySelectorAll('.ui-tabview-nav a');
            if (menuItem) {
                Array.from(menuItem).forEach(list => {
                    list.addEventListener('click', function () {
                        this.offsetParent.offsetParent.parentElement.querySelector('.ui-tabview-menu-link').innerText = this.text.trim();
                    });
                });
            }
        }
    }

    // Replace class function using add/remove/has class function
    /* istanbul ignore next */
    public replaceClass(ele, oldClass, newClass) {
        if (domHandler.hasClass(ele, oldClass)) {
            domHandler.removeClass(ele, oldClass);
            domHandler.addClass(ele, newClass);
        }
        return;
    }

    // Set accessibility for table options (multi select) element
    /* istanbul ignore next */
    public bindTableOptionAccessibility(event) {
        let mSelectElement = document.querySelector('.ui-multiselect');
        let mSelectPanel = (document.querySelector('.ui-multiselect-panel ') as HTMLElement);
        let mSelectItems = document.querySelectorAll('.ui-multiselect-items-wrapper .ui-multiselect-items .ui-multiselect-item');

        if (event.keyCode === 13) {
            if (mSelectElement.classList.contains('ui-state-focus') && (mSelectPanel.style.display === 'block')) {
                mSelectPanel.style.display = 'none';
            } else {
                [].forEach.call(mSelectItems, (item) => {
                    item.querySelector('input').addEventListener('focus', () => {
                        item.querySelector('.ui-chkbox-box').classList.add('ui-state-focus');
                    });
                    item.querySelector('input').addEventListener('blur', () => {
                        item.querySelector('.ui-chkbox-box').classList.remove('ui-state-focus');
                    });
                });
                mSelectPanel.style.display = 'block';
            }
        }
    }

    // set Accessibility for calendar components
    /* istanbul ignore next */
    public setAccessibilityCalendar() {
        // Set Focus on calendar once it open
        let calendarEle = document.querySelectorAll('.ui-calendar input');
        if (calendarEle) {
            Array.from(calendarEle).forEach(calendarEleActive => {
                calendarEleActive.addEventListener('focus', (e) => {
                    let activeElement = e.target || e.srcElement;
                    let datepicketEle = (activeElement as HTMLElement).classList.valueOf()[0];
                    setTimeout(() => {
                        if (document.querySelector('table.' + datepicketEle)) {
                            let currentdatePickerWrapper = document.querySelector('table.' + datepicketEle).parentElement;
                            currentdatePickerWrapper.setAttribute('tabindex', '0');
                            (currentdatePickerWrapper as HTMLElement).focus();
                            this.SetDisabledOtherDayLinkCalendar(currentdatePickerWrapper);
                        }
                    }, 150);
                });
            });
        }
    }

    // Skip tab/focus for disabled/other mondays days on month change
    /* istanbul ignore next */
    public SetDisabledOtherDayLinkCalendar(ele) {
        ele = ele || document.querySelector('.ui-datepicker');
        let disabledDaysEle = ele.querySelectorAll('.ui-datepicker-other-month');
        [].forEach.call(disabledDaysEle, (item) => {
            let disabledDaysEleAnchor = item.querySelector('a');
            disabledDaysEleAnchor.setAttribute('tabindex', '-1');
        });
    }

    // set Attributes as object
    /* istanbul ignore next */
    public setAttributes(el, attrs) {
        Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]));
    }

    // get browsers
    /* istanbul ignore next */
    public getBrowser(ua = window.navigator.userAgent) {
        let browser = 'unknown';

        // IE < 11
        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            return 'ie' + parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        // IE 11
        if (ua.indexOf('Trident/') > 0) {
            let rv = ua.indexOf('rv:');
            return 'ie' + parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        // Edge
        if (ua.indexOf('Edge/') > 0) {
            return 'edge';
        }

        // Chrome
        if (ua.indexOf('Chrome/') > 0) {
            return 'chrome';
        }

        // Safari
        if (ua.indexOf('Safari/') > 0) {
            return 'safari';
        }

        // Firefox
        if (ua.indexOf('Firefox/') > 0) {
            return 'firefox';
        }

        if (browser === 'unknown') {
            throw new Error('Browser detection failed for: ' + ua);
        }
    }

    // get device type
    /* istanbul ignore next */
    public getDeviceType(ua = window.navigator.userAgent) {
        if (ua.match(/(iphone|ipod|ipad)/) || ua.match(/(android)/) || ua.match(/(iemobile)/) || ua.match(/blackberry/i) || ua.match(/Mobile/i)) {
            return 'isMobile';
        } else {
            return 'isNotMobile';
        }
    }
    // Load UI Refresh css after branding
    /* istanbul ignore next */
    public loadUIRefresh() {
        const app_url = this.domStorageFB.getItem('app_url', '');
        if (this.domStorageFB.getItem('UI_REFRESH_2019_ENABLED') === 'true' && app_url) {
            if (LoggingService.uConsole) {
                console.log('Inside loading uirfersh css');
            }
            let uirefreshPath = app_url + '/al-assets/css/uirefresh2019.css';
            if (this.domStorageFB.getItem('UI_REFRESH_2019_FONT_ENABLED') === 'false') {
                uirefreshPath = app_url + '/al-assets/css/uirefreshwithoutfont2019.css';
            }
            let styles: HTMLLinkElement;
            styles = document.createElement('link');
            styles.rel = 'stylesheet';
            styles.type = 'text/css';
            styles.href = uirefreshPath;
            document.getElementsByTagName('head')[0].appendChild(styles);
        }
    }
    // set branding
    /* istanbul ignore next */
    public setBrandingStyle() {
        let styles: HTMLLinkElement;
        let brandingPath: string;

        // check browser support session storage
        if (this.domStorageFB.hasDomStorageSupport()) {
            if (this.domStorageFB.getItem('upointNextURL')) {
                brandingPath = this.domStorageFB.getItem('upointNextURL', '', true); // load from document media
                if (LoggingService.uConsole) {
                    console.log('brandingPath picked-up from upointNextURL', brandingPath);
                }
            } else {
                let brandingObj = JSON.parse(this.domStorageFB.getItem('brandingObj'));
                if (brandingObj &&  brandingObj.siteBrand) {
                    if (Object.keys(brandingObj.siteBrand).length > 0 && brandingObj.siteBrand.css && brandingObj.siteBrand.css.themeURL) {
                        brandingPath = this.getUpointNextUrl() + brandingObj.siteBrand.css.themeURL;
                    }
                }
               // brandingPath = this.domStorageFB.getItem('upointNextURL'); // load from document media
                if (LoggingService.uConsole) {
                    console.log('brandingPath picked-up from brandingObj', brandingPath);
                }
            }
            if (LoggingService.uConsole) {
                console.log('brandingPath', brandingPath);
            }
        }
        if (brandingPath !== null) {
            styles = document.createElement('link');
            styles.rel = 'stylesheet';
            styles.type = 'text/css';
            styles.href = brandingPath;
            document.getElementsByTagName('head')[0].appendChild(styles);
        }
        this.loadUIRefresh();
    }
    /**
     * Set RTL class to HTML tag for Arebic and such other Right to Left ( RTL ) languages
     * @param switchOnRTL Boolean true | false - Manually switch RTL
     */

    /* istanbul ignore next */
    public toggleRTLClass(switchOnRTL: boolean = false) {
        const htmlDoc = document.querySelector('html');

        // Get locale language from session storage object ( if available )
        let localeString: string = this.domStorageFB.getItem('lr_json_data') || this.domStorageFB.getItem('alightRequestHeader'),
            locale: any = {};

        if (localeString) {
            locale = JSON.parse(localeString);
        }

        if (locale && locale.locale) {
            htmlDoc.setAttribute('lang', locale.locale);
            if (locale.locale === 'ar_SA') {
                if (htmlDoc.className.indexOf('ui-rtl') === -1) {
                    htmlDoc.classList.add('ui-rtl');
                    htmlDoc.setAttribute('dir', 'rtl');
                }
            } else {
                if (htmlDoc.className.indexOf('ui-rtl') !== -1) {
                    htmlDoc.classList.remove('ui-rtl');
                }
                htmlDoc.setAttribute('dir', 'ltr');
            }
        } else if (switchOnRTL) {
            if (htmlDoc.className.indexOf('ui-rtl') === -1) {
                htmlDoc.classList.add('ui-rtl');
                htmlDoc.setAttribute('dir', 'rtl');
            }
        } else {
            htmlDoc.classList.remove('ui-rtl');
            htmlDoc.setAttribute('dir', 'ltr');
        }
    }

    /**
     * "Scroll To Top" or "Go to Top" link
     */

    /* istanbul ignore next */
    public scrollToTop() {
        let scrollStep = -window.scrollY / (this.scrollDuration / 15);

        let scrollInterval = setInterval(function () {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 5);
    }

    /**
     * Find closest matching ancestor of el using classname, tagName, element Id or Attribute or undefined if not found
     * @param el : DOM node elment for which we need to find ancestor
     * @param findByType string: find closest parent element by CSS class, by Attribute, by ID or by tag name. Default is by Tag Name : BY_CLASS, BY_ATTRIBUTE, BY_ID, or blank value)
     * @param findValue: class name, attribute name , element ID or TAG Name
     */

    /* istanbul ignore next */
    public findClosest(el, findByType: string, findValue) {
        if (el) {
            switch (findByType) {
                case 'BY_CLASS':
                    if (el.classList.contains(findValue)) {
                        return el;
                    } else {
                        while (el && el.parentNode && el.parentNode.nodeName !== '#document') {
                            el = el.parentNode;
                            if (el.classList.contains(findValue)) {
                                return el;
                            }
                        }
                    }
                    break;
                case 'BY_ATTRIBUTE':
                    if (el.hasAttribute(findValue)) {
                        return el;
                    } else {
                        while (el && el.parentNode && el.parentNode.nodeName !== '#document') {
                            el = el.parentNode;
                            if (el.hasAttribute(findValue)) {
                                return el;
                            }
                        }
                    }
                    break;
                case 'BY_ID':
                    if (el.id === findValue) {
                        return el;
                    } else {
                        while (el && el.parentNode && el.parentNode.nodeName !== '#document') {
                            el = el.parentNode;
                            if (el.id === findValue) {
                                return el;
                            }
                        }
                    }
                    break;
                default:
                    findValue = findValue.toLowerCase();
                    if (el.tagName && el.tagName.toLowerCase() === findValue) {
                        return el;
                    } else {
                        while (el && el.parentNode && el.parentNode.nodeName !== '#document') {
                            el = el.parentNode;
                            if (el.tagName && el.tagName.toLowerCase() === findValue) {
                                return el;
                            }
                        }
                    }
                    break;
            }
        }

        // Many DOM methods return null if they don't
        // find the element they are searching for
        // It would be OK to omit the following and just
        // return undefined
        return null;
    }

    /**
     * Get the user IP throught the webkitRTCPeerConnection
     * @param onNewIP {Function} listener function to expose the IP locally
     * @return undefined
     */

    /*
    Commented function as SrcIp data would be added by server side 2/2/2018.
      public getUserIPAddress(onNewIP) {
            // onNewIp - your listener function for new IPs
            // compatibility for firefox and chrome
            let myPeerConnection = this._window().RTCPeerConnection || this._window().mozRTCPeerConnection || this._window().webkitRTCPeerConnection,
                localIPs = {};

            function iterateIP(ip) {
                if (!localIPs[ip]) {
                    onNewIP(ip);
                }
                localIPs[ip] = true;
            }

            if (myPeerConnection) {
                let pc = new myPeerConnection({
                    iceServers: []
                }),
                    noop = function () { },
                    ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

                try {
                    // create a bogus data channel
                    pc.createDataChannel('');

                    // create offer and set local description
                    pc.createOffer().then(function (sdp) {
                        sdp.sdp.split('\n').forEach(function (line) {
                            if (line.indexOf('candidate') < 0) {
                                return;
                            }
                            line.match(ipRegex).forEach(iterateIP);
                        });

                        pc.setLocalDescription(sdp, noop, noop);
                    }).catch(function (reason) {
                        // An error occurred, so handle the failure to connect
                    });

                    // listen for candidate events
                    pc.onicecandidate = function (ice) {
                        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) {
                            return;
                        }
                        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
                    };
                } catch (error) {
                    if (console) {
                        console.log('Error in getting IP address : ', error);
                    }
                }
            }
        } */

    /* istanbul ignore next */
    public _window(): any {
        // return the native window obj
        return window;
    }

    /**
     * Track all the events on document
     * @param event
     */

    /* istanbul ignore next */
    public trackEvents(event) {
        let elementsArray = ['a', 'input', 'select', 'button', 'label', 'ui-chkbox-box', 'ui-radiobutton-box', 'ui-tabview-title'],
            elemWithAutoId,
            eventObj = {
                'eventTime': new Date(),
                'eventType': 'UxUsage',
                'eventDescription': '',
                'autoId': '',
                'timeTaken': '',
                'cssIdentifier': null,
                'destinationURL': null,
                'elementPosition': null,
                'widgetName': ''
            },
            timeStart = performance.now(),
            elementDescription = '';

        try {
            if (event.target && event.target.nodeName) {
                elemWithAutoId = this.findClosest(event.target, 'BY_ATTRIBUTE', 'auto-id');

                [].forEach.call(elementsArray, (ele) => {

                    elementDescription = event.target.title || event.target.getAttribute('aria-label') || event.target.innerText.trim() || event.target.value || event.target.getAttribute('placeholder');

                    if (event.target.nodeName.toLowerCase() === ele && elementDescription) {

                        // Get CSS class name and href value from anchor link
                        if (event.target.nodeName.toLowerCase() === 'a') {
                            eventObj['cssIdentifier'] = event.target.className;
                            eventObj['destinationURL'] = event.target.href;
                            if (event.target.href) {
                                if (event.target.href.indexOf('/sso') > -1 || event.target.href.indexOf('/ybr') > -1 || event.target.href.indexOf('/delegate') > -1) {
                                    eventObj['cssIdentifier'] = event.target.className + ' LinkType: EXTERNAL_LINK';
                                }
                            }
                        }

                        // Get node name from button element ( Button Types can be Submit, Reset or Input with type button )
                        if (event.target.nodeName.toLowerCase() === 'button' || event.target.type === 'button' || event.target.type === 'submit' || event.target.type === 'reset') {
                            eventObj['cssIdentifier'] = 'BUTTON' || event.target.nodeName;
                        }

                        if (event.target.nodeName.toLowerCase() === 'input') {
                            // Check if current element is Input element, if yes - then get it's type like checkbox, radio, textbox etc...
                            eventObj['eventDescription'] = `Title: ${elementDescription}`;
                        } else if (event.target.nodeName.toLowerCase() === 'select') {
                            eventObj['eventDescription'] = `Title: ${event.target[0].innerText}`;
                        } else {
                            eventObj['eventDescription'] = `Title: ${elementDescription}`;
                        }

                    } else if (event.target.classList.contains(ele) && elementDescription) {

                        eventObj['eventDescription'] = `Title: ${elementDescription}`;

                    } else if (event.target.parentNode) {
                        // Check if clicked element is span, i, or any child element inside A and Button.
                        elementDescription = event.target.parentNode.innerText.trim() || event.target.parentNode.title || event.target.parentNode.getAttribute('aria-label');

                        if (elementDescription) {
                            if (event.target.parentNode.nodeName.toLowerCase() === 'button' || event.target.parentNode.type === 'button' || event.target.parentNode.type === 'submit') {
                                eventObj['eventDescription'] = `Title: ${elementDescription}`;
                                eventObj['cssIdentifier'] = event.target.parentNode.nodeName;
                            } else if (event.target.parentNode.nodeName.toLowerCase() === 'a') {
                                // eventObj['eventDescription'] = `'${elementDescription}' visited - Type = ${event.target.parentNode.nodeName}`;
                                eventObj['eventDescription'] = `Title : ${elementDescription}`;
                                eventObj['cssIdentifier'] = event.target.parentNode.className;
                                eventObj['destinationURL'] = event.target.parentNode.href;
                                if (event.target.href) {
                                    if (event.target.href.indexOf('/sso') > -1 || event.target.href.indexOf('/ybr') > -1 || event.target.href.indexOf('/delegate') > -1) {
                                        eventObj['cssIdentifier'] = event.target.className + ' LinkType: EXTERNAL_LINK';
                                    }
                                }
                            }
                        }
                    }
                });

                if (elemWithAutoId) {
                    eventObj['autoId'] = elemWithAutoId.getAttribute('auto-id');
                    eventObj['widgetName'] = elemWithAutoId.nodeName.toLowerCase();
                }

                eventObj['timeTaken'] = this.getFnExecutionTime(timeStart);

                if (eventObj.eventDescription && eventObj.autoId) {
                    return eventObj;
                }

            }
        } catch (error) {
            let uConsole = this.domStorageFB.getItem('uConsole');
            if (uConsole) {
                console.log('trackEvents() : Error in getting details of clicked element.', error);
            }
        }
    }

    /* istanbul ignore next */
    public getFnExecutionTime(timeStart) {
        let timeEnd = performance.now();
        let timeTaken = timeEnd - timeStart;
        return `${timeTaken} milliseconds.`;
    }

    /* istanbul ignore next */
    public loadDynamicScript(uri, callback: any) {
        let script = document.createElement('script');
        let rState: any;
        let readyState: any;
        script.src = uri;
        // Callback for when the script fully loads.
        if (typeof callback === 'function') {
            script.onload = () => {
                if (!(rState = readyState) || rState === 'loaded' || rState === 'complete') {
                    callback(uri);
                }
            };
        }
        document.documentElement.lastElementChild.appendChild(script);
    }

    // Get focused element
    /* istanbul ignore next */
    public getActiveElement() {
        const anchor = window.getSelection().anchorNode;
        if (anchor.nodeType === 3) {
            return anchor.parentNode;
        } else if (anchor.nodeType === 1) {
            return anchor;
        }
    }

    // Get only visible items, if parent is hidden wont available
    /* istanbul ignore next */
    public isElementVisible(element) {
        try {
            return element.clientWidth !== 0 && element.clientHeight !== 0 && element.style.opacity !== 0 && element.style.visibility !== 'hidden';
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('isElementVisible fn > ', e);
            }
        }
    }

    /* istanbul ignore next */
    setTransactionPopup() {
        this.componentMethodCallSource.next();
    }

    /* istanbul ignore next */
    logOffLinkBinding() {
        this.componentMethodCallSource.next();
    }

    /* istanbul ignore next */
    public renderRedesignOnLoginHeader() {
        this.redesignOnLoginSubject.next();
    }

    // Import this function to enable transaction pop in any angular component/widget
    /* istanbul ignore next */
    isTransactionUpnFlow(flag) {
        window['isTransactionPageUpn'] = flag;
        if (flag) {
            this.setTransactionPopup();
            this.logOffLinkBinding();
        }
    }

    /**
     * Check element has event listner
     * @param element
     */
    /* istanbul ignore next */
    hasEventListner(element) {
        let elemEvents;
        try {
            if (typeof (<any>window).eventListeners === 'function') {
                elemEvents = element.eventListeners().length > 0;
            }
            return elemEvents;
        } catch (e) {
        }
    }

    /**
     * convert dot to underscore in js object keys names
     * @param object
     */
    /* istanbul ignore next */
    transformKeys(obj) {
        return Object.keys(obj).reduce(function (o, prop) {
            const value = obj[prop];
            const newProp = prop.replace('.', '_');
            o[newProp] = value;
            return o;
        }, {});
    }

    /* istanbul ignore next */
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    /* istanbul ignore next */
    public isPostAuth() {
        let alightPersonSessionToken = this.domStorageFB.getItem('alightPersonSessionToken');
        let alightSecureSessionToken = this.domStorageFB.getItem('alightSecureSessionToken');
        if ((alightPersonSessionToken !== undefined && alightPersonSessionToken !== null && alightPersonSessionToken !== '' && alightPersonSessionToken !== 'null')
            || (alightSecureSessionToken !== undefined && alightSecureSessionToken !== null && alightSecureSessionToken !== '' && alightSecureSessionToken !== 'null')) {
            return true;
        } else {
            return false;
        }
    }

    /* istanbul ignore next */
    public isPreAuth() {
        let alightPersonSessionToken = this.domStorageFB.getItem('alightPersonSessionToken');
        let alightSecureSessionToken = this.domStorageFB.getItem('alightSecureSessionToken');
        if ((alightPersonSessionToken === undefined || alightPersonSessionToken === null || alightPersonSessionToken === '' || alightPersonSessionToken === 'null')
            && (alightSecureSessionToken === undefined || alightSecureSessionToken === null || alightSecureSessionToken === '' || alightSecureSessionToken === 'null')) {
            return true;
        } else {
            return false;
        }
    }

    /* istanbul ignore next */
    public isAfEnabled() {
        let isAfEnabled = this.domStorageFB.getItem('AF_SWITCH_ON');
        if (isAfEnabled === 'true') {
            return true;
        } else {
            return false;
        }
    }

    /* istanbul ignore next */
    public isLiferay() {
        let lssValue = this.domStorageFB.getItem('LSS', '', true);
        if (lssValue === 'true') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * compress html data with base64 and lz-string
     *
     */
    /* istanbul ignore next */
    public compressPageHtml() {
        // open panels which are in closed state
        let nodesList = Array.from(document.querySelectorAll('.ui-accordion-content-wrapper'));
        if (nodesList && nodesList.length > 0) {
            nodesList.forEach(function (element: HTMLElement) {
                if (element.style.height === '0px') {
                    element.classList.add('sc-changes-added');
                    element.style.height = 'auto';
                }
            });
        }

        // adding custom css which is not loaded
        // tslint:disable-next-line: max-line-length
        const css = `
        .aui-helper-hidden { display: none!important; }
        .aui-view-lt320 .yui3-u-1-2, .aui-view-320 .yui3-u-1-2, .aui-view-lt320 .yui3-u-2-2, .aui-view-320 .yui3-u-2-2, .aui-view-480 .yui3-u-1-4, .aui-view-480 .yui3-u-2-4, .aui-view-480 .yui3-u-3-4, .aui-view-480 .yui3-u-4-4, .aui-view-720 .yui3-u-1-8, .aui-view-720 .yui3-u-2-8, .aui-view-720 .yui3-u-3-8, .aui-view-720 .yui3-u-4-8, .aui-view-720 .yui3-u-5-8, .aui-view-720 .yui3-u-6-8, .aui-view-720 .yui3-u-7-8, .aui-view-720 .yui3-u-8-8, .aui-view-960 .yui3-u-1-16, .aui-view-960 .yui3-u-2-16, .aui-view-960 .yui3-u-3-16, .aui-view-960 .yui3-u-4-16, .aui-view-960 .yui3-u-5-16, .aui-view-960 .yui3-u-6-16, .aui-view-960 .yui3-u-7-16, .aui-view-960 .yui3-u-8-16, .aui-view-960 .yui3-u-9-16, .aui-view-960 .yui3-u-10-16, .aui-view-960 .yui3-u-11-16, .aui-view-960 .yui3-u-12-16, .aui-view-960 .yui3-u-13-16, .aui-view-960 .yui3-u-14-16, .aui-view-960 .yui3-u-15-16, .aui-view-960 .yui3-u-16-16 { display:inline; float: left; position: relative; margin-left: 0%; margin-right: 0%; }
        .aui-view-960 .yui3-u-1-16 { width:6.25%; }
        .aui-view-960 .yui3-u-2-16 { width:12.5%; }
        .aui-view-960 .yui3-u-3-16 { width:18.75%; }
        .aui-view-960 .yui3-u-4-16 { width:25.0%; }
        .aui-view-960 .yui3-u-5-16 { width:31.25%; }
        .aui-view-960 .yui3-u-6-16 { width:37.5%; }
        .aui-view-960 .yui3-u-7-16 { width:43.75%; }
        .aui-view-960 .yui3-u-8-16 { width:50.0%; }
        .aui-view-960 .yui3-u-9-16 { width:56.25%; }
        .aui-view-960 .yui3-u-10-16 { width:62.5%; }
        .aui-view-960 .yui3-u-11-16 { width:68.75%; }
        .aui-view-960 .yui3-u-12-16 { width:75.0%; }
        .aui-view-960 .yui3-u-13-16 { width:81.25%; }
        .aui-view-960 .yui3-u-14-16 { width:87.5%; }
        .aui-view-960 .yui3-u-15-16 { width:92.75%; }
        .aui-view-960 .yui3-u-16-16 { width:100.0%; }
        .aui-view-lt320 .yui3-u-1-2, .aui-view-320 .yui3-u-1-2 { width:50.0%; }
        .aui-view-lt320 .yui3-u-2-2, .aui-view-320 .yui3-u-2-2 { width:100.0%; }
        .aui-view-480 .yui3-u-1-4 { width:25.0%; }
        .aui-view-480 .yui3-u-2-4 { width:50.0%; }
        .aui-view-480 .yui3-u-3-4 { width:75.0%; }
        .aui-view-480 .yui3-u-4-4 { width:100.0%; }
        .aui-view-720 .yui3-u-1-8 { width:12.5%; }
        .aui-view-720 .yui3-u-2-8 { width:25.0%; }
        .aui-view-720 .yui3-u-3-8 { width:37.5%; }
        .aui-view-720 .yui3-u-4-8 { width:50.0%; }
        .aui-view-720 .yui3-u-5-8 { width:62.5%; }
        .aui-view-720 .yui3-u-6-8 { width:75.0%; }
        .aui-view-720 .yui3-u-7-8 { width:87.5%; }
        .aui-view-720 .yui3-u-8-8 { width:100.0%; }
        `;
        const headTag = document.head || document.getElementsByTagName('head')[0];
        const styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.id = 'screenCaptureCustomCss';
        headTag.appendChild(styleTag);
        styleTag.appendChild(document.createTextNode(css));

        // capture HTML data from page
        const pageHtml = document.querySelector('html').outerHTML;
        // const encodePageHtml = window.btoa(encodeURIComponent(pageHtml));
        // const compressedHtml = compress(pageHtml);

        // restoere panels css which are opened by us
        if (nodesList && nodesList.length > 0) {
            nodesList.forEach(function (element: HTMLElement) {
                if (element.classList.contains('sc-changes-added')) {
                    element.classList.remove('sc-changes-added');
                    element.style.height = '0px';
                }
            });
        }

        // removing custom css which is added by us
        document.getElementById('screenCaptureCustomCss').remove();

        // compress data with base64
        const compressedHtml = this.compressToBase64(pageHtml);

        return compressedHtml;
    }

    /* istanbul ignore next */
    public scrollToAnchor(event) {
        try {
            if (event.target.parentElement.classList.contains('al-scrollToTop')) {
                const getNameSpace = event.target.getAttribute('href');
                const getTargetPos = document.querySelector(`[name=${getNameSpace}]`) as HTMLElement;
                (<any>window).document.scrollingElement.scrollTop = getTargetPos.offsetTop;
                event.preventDefault();
                return false;
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('AppUtility > scrollToAnchor fn error ');
            }
        }
    }

    /* istanbul ignore next */
    downloadFile(data: any, fileName?, appendAnchor?) {
        const url = window.URL.createObjectURL(data);
        const UA = (window).navigator.userAgent;
        if (window.navigator && (window).navigator.msSaveOrOpenBlob) {
            (window).navigator.msSaveOrOpenBlob(data, fileName);
            return;
        } else if (UA.match('CrIOS')) { // Chrome IOS
            const reader: any = new FileReader();
            reader.onloadend = () => {
                window.open(reader.result);
            };
            reader.readAsDataURL(data);
        } else {
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            if (appendAnchor === undefined || appendAnchor === '' || appendAnchor !== 'cloudCmsFlag') {
            document.body.appendChild(a);
            }
            // start download
            a.click();
            if (appendAnchor === undefined || appendAnchor === '' || appendAnchor !== 'cloudCmsFlag') {
            document.body.removeChild(a);
            }
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                /* istanbul ignore next */
                document.addEventListener('focus', w => {
                    window.URL.revokeObjectURL(data);
                });
            }, 100);
        }
    }
    /* istanbul ignore next */
    getPageNameFromURL() {
        let pageName = '';
        let fullPath = window.location.href;

        try {
            if (fullPath && fullPath.indexOf('/#/web') > -1) {
                pageName = fullPath.split('/#/web/')[1].split('/')[1];
            } else {
                if (fullPath && fullPath.indexOf('/web/') > -1) {
                    if (fullPath && fullPath.indexOf('#/') > -1) {
                        pageName = fullPath.split('/web/')[1].split('/')[1].split('#')[0] + '-' + fullPath.split('#/')[1];
                    } else {
                        pageName = fullPath.split('/web/')[1].split('/')[1];
                    }
                } else {
                    if (fullPath && fullPath.indexOf('#/') > -1) {
                        pageName = fullPath.split('/web/')[1].split('/')[1].split('#')[0] + '-' + fullPath.split('#/')[1];
                    } else {
                        pageName = fullPath.split('/web/')[1].split('/')[1];
                    }
                }
            }
            if (pageName) {
                if (pageName.indexOf('?') > -1) {
                    pageName = pageName.split('?')[0];
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in getting page name from browser URL. ', error);
            }
        }

        return pageName;
    }

    /* istanbul ignore next */
    public getUpointNextUrl() {
        let protocol = window.location.protocol;
        let hostname = window.location.hostname;
        let port = window.location.port;
        let upointNextUrl = '';
        let host = document.location.host;

        if (port) {
            upointNextUrl = protocol + '//' + host;
        } else {
            upointNextUrl = protocol + '//' + hostname;
        }

        return upointNextUrl;
    }

    /* istanbul ignore next */
    public getPortletData() {
        return this.portletData;
    }

    /* istanbul ignore next */
    public setPortletData(portletData: any) {
        this.portletData = portletData;
    }

    /**
     * A function to send additional attributes and it's value into newRelic logging service.
     * https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/set-custom-attribute
     * Syntax : newrelic.setCustomAttribute(string $name, string OR number $value)
     * @param attributesObject : A key value pair of attributes which we need to send to newrelic logs
     */
    /* istanbul ignore next */
    public setNewRelicCustomAttributes(attributesObject: any) {
        try {
            // First update the info object available in newRelic script
            // this.updateNewRelicInfoObj();

            const serviceClientData = JSON.parse(this.domStorageFB.getItem('serviceClients'));
            if (serviceClientData['clientsetup']) {
                attributesObject['aonClientId'] = serviceClientData['clientsetup']['primary.clientId'];
            }

            attributesObject['angularLifecycle'] = this.getDockerLifecycle();

            if (attributesObject && Object.keys(attributesObject).length > 0) {
                for (const key in attributesObject) {
                    if (attributesObject.hasOwnProperty(key)) {

                        // Check if newrelic is available in window object, if available then set new attributes into info object
                        if (this._window().newrelic) {
                            // newrelic.setCustomAttribute(string $name, string OR number $value)
                            this._window().newrelic.setCustomAttribute(key, attributesObject[key]);
                        }
                    }
                }
            }

            if (LoggingService.uConsole) {
                console.log('New relic attributes : ', attributesObject);
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('setNewRelicCustomAttributes() : Error in setting custom attributes for New Relic logs', error);
            }
        }
    }

    /**
     * Function to get application name deployed on the server.
     *
     * Application name can be upoint-dev-app, upoint-hybrid-app, upoint-base-app or upoint-hybrid-base-app.
     * @public
     * @return {String} This function will return string value : 'upoint-dev-app', 'upoint-hybrid-app', 'upoint-base-app' or 'upoint-hybrid-base-app'.
     */
    /* istanbul ignore next */
    public getAppName(): string {
        try {
            let appName = '';
            const gatewayUrl = this.domStorageFB.getItem('gatewayUrl');

            if (gatewayUrl && gatewayUrl !== null) {

                // check if INT environment
                if (gatewayUrl.indexOf('api.int') !== -1) {
                    // Check if hybrid app
                    if (this._window().Liferay) {
                        // Hybrid app
                        appName = 'upoint-hybrid-app';
                    } else {
                        // Angular first app
                        appName = 'upoint-dev-app';
                    }
                } else {
                    // Check if hybrid app
                    if (this._window().Liferay) {
                        // Hybrid app
                        appName = 'upoint-hybrid-base-app';
                    } else {
                        // Angular first app
                        appName = 'upoint-base-app';
                    }
                }

            }

            return appName;
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in getting app name for New Relic logs', error);
            }
        }
    }

    /**
     * Function to get value of Environment Lifecycle.
     * This function will return value : 'DV', 'QA', 'QC' or 'PROD'.
     * @public
     * @return {String} This function will return string value : 'DV', 'QA', 'QC' or 'PROD'.
     */
    /* istanbul ignore next */
    public getEnvironmentLifecycle(): string {
        try {
            let environmentLifecycle = '';
            const appName = this.getAppName();
            const appUrl = this.domStorageFB.getItem('app_url');

            // Check if appName is upoint-dev or hybrid-dev, then life cycle value will be DV.
            if (appName) {
                if (appName === 'upoint-dev-app' || appName === 'upoint-hybrid-app') {
                    environmentLifecycle = 'DV';
                }
            }

            if (appUrl && appUrl !== null) {
                if (appUrl.indexOf('cache.hacontent.com/upointqc') !== -1) {
                    environmentLifecycle = 'QC';
                } else if (appUrl.indexOf('hislb01.hrbpo.hewitt.com/myHRStatic') !== -1) {
                    environmentLifecycle = 'QA';
                } else if (appUrl.indexOf('cache.hacontent.com/upoint') !== -1) {
                    environmentLifecycle = 'PROD';
                }
            }

            return environmentLifecycle;
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('getEnvironmentLifecycle() - Error in getting value of Environmental Lifecycle :', error);
            }
        }
    }

    /**
     * Function to get value of Docker Lifecycle.
     * This function will return value : 'INT', 'QA', 'QC' or 'PROD'.
     * @public
     * @return {String} This function will return string value : 'INT', 'QA', 'QC' or 'PROD'.
     */
    /* istanbul ignore next */
    public getDockerLifecycle(): string {
        try {
            let dockerLifecycle = '';
            const gatewayUrl = this.domStorageFB.getItem('gatewayUrl');

            if (gatewayUrl && gatewayUrl !== null) {
                if (gatewayUrl.indexOf('api.int') !== -1 || gatewayUrl.indexOf('api-dv') !== -1) {
                    dockerLifecycle = 'INT';
                } else if (gatewayUrl.indexOf('api.qa') !== -1 || gatewayUrl.indexOf('api-qa') !== -1) {
                    dockerLifecycle = 'QA';
                } else if (gatewayUrl.indexOf('api.qc') !== -1 || gatewayUrl.indexOf('api-qc') !== -1) {
                    dockerLifecycle = 'QC';
                } else if (gatewayUrl.indexOf('api.alight') !== -1) {
                    dockerLifecycle = 'PROD';
                }
            }

            return dockerLifecycle;
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('getDockerLifecycle() - Error in getting value of Docker Lifecycle :', error);
            }
        }
    }

    /**
     * Function to update Info object available in newrelic.
     * We will update licenseKey and applicationID on the basis of environment life cycle
     * @public
     */
    /* istanbul ignore next */
    public updateNewRelicInfoObj() {
        try {
            const lifeCycle = this.getDockerLifecycle();

            if (this._window().newrelic) {
                // Store original info object into variable
                let newRelicInfoObj = this._window().newrelic.info;

                if (newRelicInfoObj && Object.keys(newRelicInfoObj).length > 0) {
                    /* istanbul ignore next */
                    if (lifeCycle) {
                        /* istanbul ignore next */
                        // if lifeCycle is QC or PROD, then update licenseKey and applicationID
                        if (lifeCycle === 'QA' || this.domStorageFB.getItem('newRelicTestQA')) {
                            newRelicInfoObj['licenseKey'] = 'e89d56e69b';
                            newRelicInfoObj['applicationID'] = '351429272';
                        } else if (lifeCycle === 'QC' || this.domStorageFB.getItem('newRelicTestQC')) {
                            newRelicInfoObj['licenseKey'] = '53d70c9b3a';
                            newRelicInfoObj['applicationID'] = '280890108';
                        } else if (lifeCycle === 'PROD' || this.domStorageFB.getItem('newRelicTestPROD')) {
                            newRelicInfoObj['licenseKey'] = 'd68deaa78a';
                            newRelicInfoObj['applicationID'] = '351476973';
                        }
                    }

                    this._window().newrelic.info = newRelicInfoObj;

                    if (LoggingService.uConsole) {
                        console.log('updateNewRelicInfoObj() - Updated newRelic info object :', this._window().newrelic.info);
                    }
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('updateNewRelicInfoObj() - Error in updating newRelic info object :', error);
            }
        }
    }

    /**
     * getValueFromChannelRequestData():
     *
     * This function is useful for getting value of channelRequestData from alightRequestHeader in an Object format.
     * This function will return an object with key : value pair.
     *
     * Usage : this.getValueFromChannelRequestData()['pageName']
     */
    /* istanbul ignore next */
    public getValueFromChannelRequestData() {
        // Alight Request Header value
        const aRH = this.domStorageFB.getItem('alightRequestHeader', 'sessionStorage');

        try {
            if (aRH) {
                const aRHJson = JSON.parse(aRH);
                // Channel Request Data
                const CRData = aRHJson.channelRequestData;
                if (CRData) {

                    const CRDataObj = CRData.split('::').reduce((accumulator: any, key: string, i: number, array: any) => {
                        // in case the current key's index is an
                        // even value AND it is not an empty string
                        return i % 2 === 0 && key
                            // include the "key: value" pair into the dictionary
                            ? { ...accumulator, [key]: array[i + 1] }
                            // else - continue
                            : accumulator;
                    }, {});

                    return CRDataObj;
                }
            }

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error in getting attribute and value from ARH channelRequestData : ', error);
            }
        }
    }

    /**
     * Extract Timestamp from Global session ID available in Channel Request Data in ARH
     */
    /* istanbul ignore next */
    public getTimestampFromGblsId() {
        let timeStamp = '';
        let globalSessionId = this.getGlobalSessionID();

        try {
            if (globalSessionId) {
                timeStamp = globalSessionId.split('_')[1] || '';

                if (!timeStamp) {
                    let channelRequestDataObj = this.getValueFromChannelRequestData();

                    if (channelRequestDataObj && channelRequestDataObj.gblsId) {
                        globalSessionId = channelRequestDataObj.gblsId;
                        timeStamp = globalSessionId.split('_')[1] || '';
                    }
                }
            } else {
                let channelRequestDataObj = this.getValueFromChannelRequestData();

                if (channelRequestDataObj && channelRequestDataObj.gblsId) {
                    globalSessionId = channelRequestDataObj.gblsId;
                    timeStamp = globalSessionId.split('_')[1] || '';
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('getTimestampFromGblsId() error occurred : ', error);
            }
        }

        if (timeStamp) {
            this.domStorageFB.setItem('sessionCreatedTimestamp', timeStamp, 'sessionStorage');
        }

        return timeStamp;
    }

    /* istanbul ignore next */
    public getSessionCreatedTimeStamp() {
        let sessionTimestamp = this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage');

        if (sessionTimestamp && sessionTimestamp !== 'null' && sessionTimestamp !== 'undefined') {
            return sessionTimestamp;
        } else {
            let timeStamp = this.getTimestampFromGblsId();
            if (timeStamp) {
                this.domStorageFB.setItem('sessionCreatedTimestamp', timeStamp, 'sessionStorage');
                sessionTimestamp = this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage');
            }
        }
        return sessionTimestamp;
    }

    /**
     * This function is useful to add new multiple attributes to channelRequestData in alightRequestHeader (ARH).
     *
     * Example of Usage:
     *
     * ```javascript
     * this.updateChannelRequestData({
     *     'AttributeName1': 'AttributeValue1',
     *     'AttributeName2': 'AttributeValue2'
     * });
     * ```
     */
    /* istanbul ignore next */
    public updateChannelRequestData(attributesObj: any) {
        let aRH = this.domStorageFB.getItem('alightRequestHeader', 'sessionStorage');
        try {
            if (aRH) {
                let aRHJson = JSON.parse(aRH);
                let CRData = aRHJson.channelRequestData;
                if (CRData) {
                    let newCRD: any = '';

                    Object.keys(attributesObj).map((attribute: any) => {
                        // If attribute NOT available, Add new Attribute
                        if (CRData.lastIndexOf('::' + attribute + '::') === -1) {
                            // newCRD = newCRD + attribute + '::' + (attributesObj[attribute] || null) + '::';
                            CRData = CRData + attribute + '::' + (attributesObj[attribute] || null) + '::';
                        } else {
                            // If attribute is already available then update it's value
                            // newCRD = '';
                            let attrRegEx = new RegExp('(' + attribute + '::).+?(?=::)', 'gi');
                            CRData = CRData.replace(attrRegEx, attribute + '::' + (attributesObj[attribute] || null));
                        }
                    });

                    newCRD = CRData;

                    if (LoggingService.uConsole) {
                        console.log('updateChannelRequestData() : newCRD = ', newCRD, ' CRData = ', CRData);
                    }

                    let updatedARH = this.addAttributeToJsonObject('channelRequestData', newCRD, aRHJson);
                    this.domStorageFB.setItem('alightRequestHeader', JSON.stringify(updatedARH), 'sessionStorage');
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('updateChannelRequestData() : Error in updating channelRequestData : ', error);
            }
        }
    }

    /* istanbul ignore next */
    public addAttributeToJsonObject(attrName: any, attrValue: any, jsonObject: any) {
        try {
            if (jsonObject !== null) {
                jsonObject[attrName] = attrValue;
                return jsonObject;
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('addAttributeToJsonObject() : Error in adding attributes to JSON object : ', error);
            }
        }
    }

    /**
     * Function for getting GlobalSessionId from alightRequestHeader ( ARH ).
     * This globalSession value will be sent with logging details to server.
     */
    /* istanbul ignore next */
    public getGlobalSessionID() {
        let globalSessionId = '';

        try {
            let alightRequestHeaderValue = JSON.parse(this.domStorageFB.getItem('alightRequestHeader', 'sessionStorage'));
            if (alightRequestHeaderValue) {
                let channelReqData = alightRequestHeaderValue.channelRequestData;
                let dataValue = channelReqData.split('::');
                let gblsDataIndexValue = dataValue.indexOf('gblsId');
                if (gblsDataIndexValue !== -1) {
                    globalSessionId = dataValue[gblsDataIndexValue + 1];
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('In AppUtility.getGlobalSessionID() error occurred ', error);
            }
        }

        return globalSessionId;
    }

        /* istanbul ignore next */
    public isSwFeatureEnabled(enableAFCheck?: boolean): boolean {
        // UFD-1558, UFD-2146
        if (this.domStorageFB.getItem('enableSwDynamicCache') && (this.domStorageFB.getItem('enableSwDynamicCache') === true || this.domStorageFB.getItem('enableSwDynamicCache') === 'true')) {
            return true;
        } else {
            return false;
        }
    }

    /* istanbul ignore next */
    public isSWFeatureEnabledForPageName(instanceName: string) {
        // UFD-1558, UFD-2146
        let flag = false;
        try {
            let pageName = this.getPageNameFromURL();
            let c = this.getSWConfFromStorage();
            if (c && c !== null) {
                Object.keys(c).forEach((key) => {
                    if (pageName) {
                        if (key === pageName) {
                            let endPoints = this.swConfig[key];
                            let array = endPoints['endPoints'];
                            if (array.indexOf(instanceName) > -1) {
                                flag = true;
                            }
                        }
                    }
                });
            }
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('AppUtility| isSWFeatureEnabledForPageName() - Error!!! - ', e);
            }
        }
        return flag;
    }

    /**
     * Method to check if a storage or endpoint is defined in configuration at any level.
     */
    /* istanbul ignore next */
    public isSWFeatureEnabledForStore(storeName: string) {
        // UFD-1558, UFD-2146
        let flag = false;
        try {
            let c = this.getSWConfFromStorage();
            if (c && c !== null) {
                Object.keys(c).forEach((key) => {
                    let endPoints = this.swConfig[key];
                    let array = endPoints['endPoints'];
                    if (array.indexOf(storeName) > -1) {
                        flag = true;
                    }
                });
            }
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('AppUtility| isSWFeatureEnabledForStore() - Error!!! - ', e);
            }
        }
        return flag;
    }

    /**
     * Method to get service worker Json fromt the storage.
     * Default null.
     */
    /* istanbul ignore next */
    public getSWConfFromStorage(): {} {
        // UFD-1558, UFD-2146
        let c = null;
        try {
            let s = this.domStorageFB.getItem('swconf');
            if (s && s !== null) {
                c = JSON.parse(s);
            }

        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('AppUtility| getSWConfFromStorage() - Error!!! - ', c, e);
            }
            c = null;
        }
        return c;
    }

    /**
     * Invoked on App startup to update SW configuraion in storage.
     * c: string - Json in string format.
     */
    /* istanbul ignore next */
    public saveSWConfInStorage(c: string): void {
         // UFD-1558, UFD-2146
        try {
            if (c && c !== null && Object.keys(c).length > 0) {
                this.domStorageFB.setItem('swconf', c);
                return ;
            }
            this.domStorageFB.removeItem('swconf');
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('AppUtility| saveSWConfInStorage() - Error!!! - ', c, e);
            }
            this.domStorageFB.removeItem('swconf');
        }
    }

    /* istanbul ignore next */
    public getSWConfiguration(): {} {
        // UFD-1558, UFD-2146
        // TODO - dynamic logic to be added here.
        // Invoke service
        return this.swConfig;
    }

    /* istanbul ignore next */
    public getAllSWFeatureEnabledStoreNames(): any {
        // UFD-1558, UFD-2146
        let stores = [];
        try {
            let c = this.getSWConfFromStorage();
            if (c && c !== null) {
                Object.keys(c).forEach((key) => {
                    let endPoints = this.swConfig[key];
                    let arrayStores = endPoints['endPoints'];
                    for (let ss = 0; ss < arrayStores.length; ss++) {
                        if (stores.indexOf(arrayStores[ss]) < 0) {
                            stores.push(arrayStores[ss]);
                        }
                    }
                });
            }
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('AppUtility| isSWFeatureEnabledForStore() - Error!!! - ', e);
            }
        }
        return stores;
    }
    public getLocaleValue() {
        let locale = undefined;
        if (this.domStorageFB.getItem('lr_json_data') && JSON.parse(this.domStorageFB.getItem('lr_json_data')).locale) {
            locale = JSON.parse(this.domStorageFB.getItem('lr_json_data')).locale;
        } else if (this.domStorageFB.getItem('alightRequestHeader') && JSON.parse(this.domStorageFB.getItem('alightRequestHeader')).locale) {
            locale = JSON.parse(this.domStorageFB.getItem('alightRequestHeader')).locale;
        }
        return locale;
    }

    /* istanbul ignore next */
    public compressToBase64(input) {
        let keyStrBase64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        if (input == null) { return ''; }
        let res = this._compress(input, 6, function(a) {return keyStrBase64.charAt(a); });
        switch (res.length % 4) { // To produce valid Base64
        default: // When could this happen ?
        case 0 : return res;
        case 1 : return res + '===';
        case 2 : return res + '==';
        case 3 : return res + '=';
        }
    }

    /* istanbul ignore next */
    public _compress(uncompressed, bitsPerChar, getCharFromInt) {
        // tslint:disable-next-line: quotemark
        if (uncompressed == null) { return ""; }
        let i, value,
            context_dictionary = {},
            context_dictionaryToCreate = {},
            context_c = '',
            context_wc = '',
            context_w = '',
            context_enlargeIn = 2, // Compensate for the first entry which should not count
            context_dictSize = 3,
            context_numBits = 2,
            context_data = [],
            context_data_val = 0,
            context_data_position = 0,
            ii;

        for (ii = 0; ii < uncompressed.length; ii += 1) {
          context_c = uncompressed.charAt(ii);
          if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
            context_dictionary[context_c] = context_dictSize++;
            context_dictionaryToCreate[context_c] = true;
          }

          context_wc = context_w + context_c;
          if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
            context_w = context_wc;
          } else {
            if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
              if (context_w.charCodeAt(0) < 256) {
                for (i = 0 ; i < context_numBits ; i++) {
                  // tslint:disable-next-line: no-bitwise
                  context_data_val = (context_data_val << 1);
                  if (context_data_position === bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                }
                value = context_w.charCodeAt(0);
                for (i = 0 ; i < 8 ; i++) {
                  // tslint:disable-next-line: no-bitwise
                  context_data_val = (context_data_val << 1) | (value & 1);
                  if (context_data_position === bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  // tslint:disable-next-line: no-bitwise
                  value = value >> 1;
                }
              } else {
                value = 1;
                for (i = 0 ; i < context_numBits ; i++) {
                  // tslint:disable-next-line: no-bitwise
                  context_data_val = (context_data_val << 1) | value;
                  if (context_data_position === bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = 0;
                }
                value = context_w.charCodeAt(0);
                for (i = 0 ; i < 16 ; i++) {
                  // tslint:disable-next-line: no-bitwise
                  context_data_val = (context_data_val << 1) | (value & 1);
                  if (context_data_position === bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  // tslint:disable-next-line: no-bitwise
                  value = value >> 1;
                }
              }
              context_enlargeIn--;
              if (context_enlargeIn === 0) {
                context_enlargeIn = Math.pow(2, context_numBits);
                context_numBits++;
              }
              delete context_dictionaryToCreate[context_w];
            } else {
              value = context_dictionary[context_w];
              for (i = 0 ; i < context_numBits ; i++) {
                // tslint:disable-next-line: no-bitwise
                context_data_val = (context_data_val << 1) | (value & 1);
                if (context_data_position === bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                // tslint:disable-next-line: no-bitwise
                value = value >> 1;
              }


            }
            context_enlargeIn--;
            if (context_enlargeIn === 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            // Add wc to the dictionary.
            context_dictionary[context_wc] = context_dictSize++;
            context_w = String(context_c);
          }
        }

        // Output the code for w.
        if (context_w !== '') {
          if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
            if (context_w.charCodeAt(0) < 256) {
              for (i = 0 ; i < context_numBits ; i++) {
                // tslint:disable-next-line: no-bitwise
                context_data_val = (context_data_val << 1);
                if (context_data_position === bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
              }
              value = context_w.charCodeAt(0);
              for (i = 0 ; i < 8 ; i++) {
                // tslint:disable-next-line: no-bitwise
                context_data_val = (context_data_val << 1) | (value & 1);
                if (context_data_position === bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                // tslint:disable-next-line: no-bitwise
                value = value >> 1;
              }
            } else {
              value = 1;
              for (i = 0 ; i < context_numBits ; i++) {
                // tslint:disable-next-line: no-bitwise
                context_data_val = (context_data_val << 1) | value;
                if (context_data_position === bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = 0;
              }
              value = context_w.charCodeAt(0);
              for (i = 0 ; i < 16 ; i++) {
                // tslint:disable-next-line: no-bitwise
                context_data_val = (context_data_val << 1) | (value & 1);
                if (context_data_position === bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                // tslint:disable-next-line: no-bitwise
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn === 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            delete context_dictionaryToCreate[context_w];
          } else {
            value = context_dictionary[context_w];
            for (i = 0 ; i < context_numBits ; i++) {
              // tslint:disable-next-line: no-bitwise
              context_data_val = (context_data_val << 1) | (value & 1);
              if (context_data_position === bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              // tslint:disable-next-line: no-bitwise
              value = value >> 1;
            }


          }
          context_enlargeIn--;
          if (context_enlargeIn === 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
        }

        // Mark the end of the stream
        value = 2;
        for (i = 0 ; i < context_numBits ; i++) {
          // tslint:disable-next-line: no-bitwise
          context_data_val = (context_data_val << 1) | (value & 1);
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          // tslint:disable-next-line: no-bitwise
          value = value >> 1;
        }

        // Flush the last char
        while (true) {
          // tslint:disable-next-line: no-bitwise
          context_data_val = (context_data_val << 1);
          if (context_data_position === bitsPerChar - 1) {
            context_data.push(getCharFromInt(context_data_val));
            break;
          } else { context_data_position++; }
        }
        return context_data.join('');
    }

    /* istanbul ignore next */
    public getOrgName() {
        if (this.domStorageFB.getItem('lr_json_data') && JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName) {
            return JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName;
        } else {
            return window.location.href.split('/web/')[1].split('/')[0];
        }
    }

    /* istanbul ignore next */
    public storePIDataIntoSessionStorage<T>(key: string, value: T, instanceName: string) {
        if (instanceName === 'tiles') {
            let tileGrpName = key;
            let  groupTileInfo = {};
            if (value && value[0] && value[0]['tileResponse']) {
                groupTileInfo = value[0]['tileResponse'];
                if (groupTileInfo['structureDataOnly'] !== undefined && groupTileInfo['structureDataOnly']) {
                    // here we are getting cached data, so no need to seperate the structura & User data again.
                    return value;
                } else {
                    if (groupTileInfo['dataTile'] || (groupTileInfo['isdatatile'] && groupTileInfo['isdatatile'] === 'true')) {
                        let respDataArray = new Array();
                        if (groupTileInfo['cellModal'] !== undefined) {
                            if (groupTileInfo['dataTile'] && !groupTileInfo['transactional']) {
                                for (let _rowList = 0; _rowList < groupTileInfo['cellModal'].length; _rowList++) {
                                    for (let _colList = 0; _colList < groupTileInfo['cellModal'][_rowList].length; _colList++) {
                                        for (let _tileList = 0; _tileList < groupTileInfo['cellModal'][_rowList][_colList]['tileList'].length; _tileList++) {
                                            let tileInfo = groupTileInfo['cellModal'][_rowList][_colList]['tileList'][_tileList];
                                            if (tileInfo['isdatatile'] !== undefined && tileInfo['isdatatile'] === 'true') {
                                                let item = {};
                                                let tilename = tileInfo['TileNm'];
                                                if (LoggingService.uConsole) {
                                                    console.log('APPUtility | storePIDataIntoSessionStorage method - Tile Name is : ' + tilename);
                                                }
                                                // Update the PI data elements with blank value
                                                for (const tileElem of Object.keys(tileInfo)) {
                                                    if (tileInfo['hide' + tileElem] !== undefined) {
                                                        if (item && item['tileName'] === undefined) {
                                                            item['tileName'] = tilename;
                                                        }
                                                        item[tileElem] = tileInfo[tileElem];
                                                        tileInfo[tileElem] = '';
                                                    }
                                                }
                                                respDataArray.push(item);
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            // this block is for Lazy load feature and individual tile repsonses
                            let tileInfo = groupTileInfo;
                            let tilename = tileInfo['TileNm'];
                            if (LoggingService.uConsole) {
                                console.log('APPUtility | storePIDataIntoSessionStorage method for lazy laod tile - Tile Name is : ' + tilename);
                            }
                            const item = {};
                            // Update the PI data elements with blank value
                            for (const tileElem of Object.keys(tileInfo)) {
                                if (tileInfo['hide' + tileElem] !== undefined) {
                                    if (item && item['tileName'] === undefined) {
                                        item['tileName'] = tilename;
                                    }
                                    item[tileElem] = tileInfo[tileElem];
                                    tileInfo[tileElem] = '';
                                }
                            }
                            respDataArray.push(item);
                        }
                        groupTileInfo['structureDataOnly'] = true;
                        value[0]['tileResponse'] = groupTileInfo;
                        // this.domStorageFB.setItem('TILE_DISPLAY_DATA_' + tileGrpName, JSON.stringify(respDataArray));
                        this.domStorageFB.setItem('TILE_DISPLAY_DATA_' + tileGrpName, this.compressToBase64(JSON.stringify(respDataArray)));
                    }
                }
            }
        }
        return value;
    }
    // public storePIDataIntoSessionStorage<T>(key: string, value: T, instanceName: string) {
    //     if (this.isSwFeatureEnabled() && instanceName === 'tiles') {
    //         let tileGrpName = key;
    //         const tilestructuralElements: any = {};
    //         tilestructuralElements.data = {
    //             'contents': ['treatment', 'aonRedesignEnableForNonDataTile', 'tileid', 'tiletypecss', 'tileColor', 'tileGrpName', 'linkOnClick', 'isLazyLoad',
    //             'title', 'linkHref', 'linkTitle', 'tileType', 'isMaskable', 'templateName', 'tileTechnicalName', 'baseClntInd',
    //             'aonUpointRedesignEnable', 'namespace', 'Domain', 'TileNm', 'tileEyeImageTitle', 'imageURL', 'ImgSrc', 'isSupportedTemp']
    //         };
    //         const structuralElement = tilestructuralElements.data.contents;
    //         let  groupTileInfo = {};
    //         if (value && value[0] && value[0]['tileResponse'] ) {
    //             groupTileInfo = value[0]['tileResponse'];
    //             let respDataArray = new Array();
    //             if (groupTileInfo['structureDataOnly'] !== undefined && groupTileInfo['structureDataOnly']) {
    //                 // here we are getting cached data, so no need to seperate the structura & User data again.
    //                 return value;
    //             } else {
    //                 if (groupTileInfo['cellModal'] !== undefined) {
    //                     for (let _rowList = 0; _rowList < groupTileInfo['cellModal'].length; _rowList++) {
    //                         for (let _colList = 0; _colList < groupTileInfo['cellModal'][_rowList].length; _colList++) {
    //                             for (let _tileList = 0; _tileList < groupTileInfo['cellModal'][_rowList][_colList]['tileList'].length; _tileList++) {
    //                                 let item = {};
    //                                 let tileInfo = groupTileInfo['cellModal'][_rowList][_colList]['tileList'][_tileList];
    //                                 let tilename = tileInfo['TileNm'];
    //                                 if (LoggingService.uConsole) {
    //                                     console.log('APPUtility | storePIDataIntoSessionStorage method - Tile Name is : ' + tilename);
    //                                 }
    //                                 // if (tileGrpName === undefined || tileGrpName === null) {
    //                                 //     tileGrpName = tileInfo['tileGrpName'];
    //                                 // }
    //                                 for (const tileElem of Object.keys(tileInfo)) {
    //                                     let structElement: boolean = false;
    //                                     for (let element of structuralElement) {
    //                                         if (tileElem === element) {
    //                                             structElement = true;
    //                                             break;
    //                                         }
    //                                     }
    //                                     if (!structElement) {
    //                                         if (item && item['tileName'] === undefined) {
    //                                             item['tileName'] = tilename;
    //                                         }
    //                                         item[tileElem] = tileInfo[tileElem];
    //                                         tileInfo[tileElem] = '';
    //                                     }
    //                                 }
    //                                 respDataArray.push(item);
    //                             }
    //                         }
    //                     }
    //                 } else {
    //                     // this block is for Lazy load feature and individual tile repsonses
    //                     let tileInfo = groupTileInfo;
    //                     let tilename = tileInfo['TileNm'];
    //                     if (LoggingService.uConsole) {
    //                         console.log('APPUtility | storePIDataIntoSessionStorage method for lazy laod tile - Tile Name is : ' + tilename);
    //                     }
    //                     // if (tileGrpName === undefined || tileGrpName === null) {
    //                     //     tileGrpName = tilename;
    //                     // }
    //                     const item = {};
    //                     for (const tileElem of Object.keys(tileInfo)) {
    //                         let structElement: boolean = false;
    //                         for (let element of structuralElement) {
    //                             if (tileElem === element) {
    //                                 structElement = true;
    //                                 break;
    //                             }
    //                         }
    //                         if (!structElement) {
    //                             if (item && item['tileName'] === undefined) {
    //                                 item['tileName'] = tilename;
    //                             }
    //                             item[tileElem] = tileInfo[tileElem];
    //                             tileInfo[tileElem] = '';
    //                         }
    //                     }
    //                     respDataArray.push(item);
    //                 }
    //                 groupTileInfo['structureDataOnly'] = true;
    //                 value[0]['tileResponse'] = groupTileInfo;
    //                 // this.domStorageFB.setItem('TILE_DISPLAY_DATA_' + tileGrpName, JSON.stringify(respDataArray));
    //                 if (!groupTileInfo['transactional']) {
    //                     this.domStorageFB.setItem('TILE_DISPLAY_DATA_' + tileGrpName, this.compressToBase64(JSON.stringify(respDataArray)));
    //                 }
    //             }
    //         }
    //     }
    //     return value;
    // }

}

